import { TableComponent as Table } from '../../components'
import moment from 'moment';
import { maskCurrency } from '../../utils/functions';
import { Empty } from 'antd';

const StatementTable = (props) => {
    const { data, contractType } = props
    
    // Garantir que data seja sempre um array
    const safeData = Array.isArray(data) ? data : []
    
    // Se não houver dados, mostrar mensagem
    if (!safeData || safeData.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <Empty 
                    description={
                        <span>
                            Nenhuma operação encontrada para este contrato.<br/>
                            <small style={{ color: '#999' }}>
                                Tipo: {contractType || 'N/A'}
                            </small>
                        </span>
                    }
                />
            </div>
        )
    }
    
    const columns = [
        {
            title: 'Data',
            dataIndex: 'dataOperacao',
            key: 'dataOperacao',
            align: 'center',
            render: date => moment(date).format('DD/MM/YYYY')
        },
        {
            title: 'Total (R$)',
            dataIndex: 'totalFlow',
            key: 'totalFlow',
            align: 'center',
            render: value => 'R$'+maskCurrency(value)
        },
        {
            title: 'Lucro Cliente (R$)',
            dataIndex: 'lucroCliente',
            key: 'lucroCliente',
            align: 'center',
            render: value => 'R$'+maskCurrency(value)
        },
        {
            title: 'RDN',
            dataIndex: 'rentabilidadeDiariaNormal',
            key: 'rentabilidadeDiariaNormal',
            align: 'center', 
            render: value => parseFloat(value).toFixed(4)+"%" 
        },
        {
            title: 'RAM',
            dataIndex: 'rentabilidadeMes',
            key: 'rentabilidadeMes',
            align: 'center', 
            render: value => parseFloat(value).toFixed(4)+"%"
        },
        {
            title: 'Operação',
            dataIndex: 'tipoOperacao',
            key: 'tipoOperacao',
            align: 'center',  
        },
    ]
    
    return (
        <div>
            <Table column={columns} data={safeData} />
        </div>
    )
}

export default StatementTable